import { Theme } from "@emotion/react";

export const theme: Theme = {
  color: {
    primaryBackground: "#fef9f8",
    secondaryBackground: "#ef9273",
    primaryText: "#0d0d0d",
    secondaryText: "#ffffff",
    primaryAccent: "#CACACA",
    secondaryAccent: "#141519",
  },
};
